import { skipToken, } from '@tanstack/react-query';
import { getAuthorizationHeader } from './sitFetcher';
/**
 * Context injected into every react-query hook wrappers
 *
 * @param queryOptions options from the useQuery wrapper
 */
export function useSitContext(_queryOptions) {
    const headers = getAuthorizationHeader();
    return {
        fetcherOptions: {
            headers,
        },
        queryOptions: {},
    };
}
export const queryKeyFn = (operation) => {
    const queryKey = hasPathParams(operation)
        ? operation.path
            .split('/')
            .filter(Boolean)
            .map((i) => resolvePathParam(i, operation.variables.pathParams))
        : operation.path.split('/').filter(Boolean);
    if (hasQueryParams(operation)) {
        queryKey.push(operation.variables.queryParams);
    }
    if (hasBody(operation)) {
        queryKey.push(operation.variables.body);
    }
    return queryKey;
};
// Helpers
const resolvePathParam = (key, pathParams) => {
    if (key.startsWith('{') && key.endsWith('}')) {
        return pathParams[key.slice(1, -1)];
    }
    return key;
};
const hasPathParams = (operation) => {
    if (operation.variables === skipToken)
        return false;
    return 'variables' in operation && 'pathParams' in operation.variables;
};
const hasBody = (operation) => {
    if (operation.variables === skipToken)
        return false;
    return ('variables' in operation &&
        'body' in operation.variables &&
        operation.variables.body !== undefined);
};
const hasQueryParams = (operation) => {
    if (operation.variables === skipToken)
        return false;
    return ('variables' in operation &&
        'queryParams' in operation.variables &&
        operation.variables.queryParams !== undefined);
};
//# sourceMappingURL=sitContext.js.map